export const dashboardEntry = {
  key: 'compliance',
  title: 'Compliance',
  description: 'See how you measure up against frameworks like ISO 27001 and SOC 2, which controls are failing and the evidence behind them.',
  route: '/dashboards/compliance',
  // Lucide icon name in kebab-case; the hub maps it to a component.
  icon: 'clipboard-check',
  // Framework results come from Posture; training evidence from Aware.
  apps: ['posture', 'aware'],
  // Posture compliance and the training report are owner/admin only.
  adminOnly: true,
} as const;
